export default "__VITE_ASSET__e3eebff4__"